import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { ApplicationInvitationDetail } from 'types/api'
import { BaseParams } from 'types/utils'

export function useInvitation({ id }: BaseParams<{}>) {
  async function getInvitation() {
    const response = await apiClient.get<ApplicationInvitationDetail>(
      `${SNA_PREFIX}invitations/${id}/`
    )
    return response.data
  }

  return useQuery({
    queryFn: getInvitation,
    queryKey: ['invitation', id],
    enabled: !!id
  })
}
